import { getOperationName } from '@apollo/client/utilities';

import {
  IndicationForm_IndicationAcknowledgementsDocument,
  IndicationForm_UnacknowledgeIndicationMutationVariables,
  useIndicationForm_UnacknowledgeIndicationMutation,
} from '../graphql/__generated__';

export function refetchQueries() {
  const refetchInstitutionalIndicationAcknowledgementsQuery = getOperationName(
    IndicationForm_IndicationAcknowledgementsDocument
  );
  return [refetchInstitutionalIndicationAcknowledgementsQuery!];
}

export const useUnacknowledgeInstitutionalIndicationMutation = (
  variables: IndicationForm_UnacknowledgeIndicationMutationVariables
) =>
  useIndicationForm_UnacknowledgeIndicationMutation({
    variables,
    refetchQueries,
    awaitRefetchQueries: true,
  });
